import { render } from "./ContactUsPage.vue?vue&type=template&id=330dc25e&scoped=true"
import script from "./ContactUsPage.vue?vue&type=script&lang=js"
export * from "./ContactUsPage.vue?vue&type=script&lang=js"

import "./ContactUsPage.vue?vue&type=style&index=0&id=330dc25e&scoped=true&lang=css"

import exportComponent from "../../dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-330dc25e"]])

export default __exports__